import { Device } from '../../../../../../../types/Device';
import './styles.css';
import useLayoutPositionsStore from '../../api/layoutPositions/layoutPositions';
import { DeviceTime } from './components/DeviceTime/DeviceTime';

interface ModalCameraGridProps {
    devices: Device[];
    selectedDevices: Device[];
    onTileClick: (device: Device) => void;
    getTileStatus?: (device: Device) => {
        isDisabled?: boolean;
        tooltip?: string;
        highlight?: 'audio' | 'video' | 'photo';
    };
}

export const ModalCameraGrid: React.FC<ModalCameraGridProps> = ({
    devices,
    selectedDevices,
    onTileClick,
    getTileStatus,
}) => {
    // Рассчитываем оптимальное количество колонок
    const columnCount = Math.min(Math.ceil(Math.sqrt(devices.length)), 4);
    return (
        <div
            style={{
                display: 'grid',
                gridTemplateColumns: `repeat(${columnCount}, 1fr)`,
                gap: '8px',
                width: '100%',
            }}
        >
            {devices.map((device, index) => {
                const status = getTileStatus?.(device) || {};
                const isSelected = selectedDevices.some((d) => d.UID === device.UID);

                return (
                    // <></>
                    <DeviceTime
                        key={device.UID}
                        device={device}
                        isSelected={isSelected}
                        isDisabled={status.isDisabled}
                        tooltip={status.tooltip}
                        highlight={status.highlight}
                        onTileClick={onTileClick}
                    />
                );
            })}
        </div>
    );
};
